import { constants } from '@clubmed/utils';
import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import React from 'react';
const { OFFERS } = constants;
type DiscountsLineProps = {
  discounts: Array<ProposalDiscount>;
};
export const DiscountsLine = ({ discounts }: DiscountsLineProps) => {
  if (!discounts?.length) {
    return null;
  }

  return (
    <div className="my-10">
      {discounts.map((discount: ProposalDiscount) => (
        <div
          className="mb-20 rounded-12 border-1 border-success bg-white p-20"
          key={discount.offerId}
        >
          <div className="flex w-full justify-between">
            <div className="flex w-2/3 md:gap-10">
              <Icon
                name={discount.offerId !== OFFERS.PROMO_CODE ? ICONS.PROMOTION : ICONS.PROMO_CODE}
                width="1.875rem"
              />
              <div className="flex flex-col">
                <p
                  className="mb-0 font-bold leading-normal"
                  style={{
                    color: discount.offerColor,
                  }}
                >
                  {discount.offerId !== 'AVA'
                    ? t('booking.summary.discount.discountLabel')
                    : t('booking.summary.discount.discountCodeLabel')}
                </p>
                <p className="mb-0 leading-tight">
                  {discount.currentProposalCode?.label || discount.offerLabel}
                </p>
                {discount.currentProposalCode?.description ||
                  (discount.offerDescription && (
                    <p className="mb-0 leading-tight">
                      {discount.currentProposalCode?.description || discount.offerDescription}
                    </p>
                  ))}
              </div>
            </div>
            <div>
              <p
                className="text-14 font-bold text-success"
                style={{
                  color: discount.offerColor,
                }}
              >
                - {discount.amount.formattedValue}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
